module.exports = __webpack_public_path__ + "static/media/default-icon.db2fa3da.svg";